import { EMBLA_JS_FILE, EMBLA_LOADED_VAR } from '../config/main';
import dropFile from '../functions/dropFile';
import { select } from '../functions/select';
import { setSwitchers } from '../functions/setSwitchers';
import textlimit from '../functions/textlimit';
import { querySelectorAll } from '../functions/querySelectors';
import { setListenersFromSelector } from '../functions/listeners';
import lazyJs from '../functions/lazyJs';
import { initDomSlider } from '../modules/domSlider';
import { setTables } from '../functions/setTables';

const DROP_FILE_CLASS = 'js-add-file';
export const GALLERY_CLASS = 'c-page-gallery__list';
export const SELECT_CLASS = 'js-select';
const TEXTLIMIT_TEXTAREA_CLASS = 'js-text-limit';
const TEXTLIMIT_SPAN_CLASS = 'js-text-free';
const CHAT_LINK_CLASS = 'js-open-chat';
const CHAT_LINK_ACTIVE_CLASS = 'joc-init';

let setSelects = function() {
  let inputs = querySelectorAll(`.${SELECT_CLASS}`);

  inputs.forEach((input) => {
    select(input);
  });
};

let setDropFiles = function() {
  let files = querySelectorAll(`.${DROP_FILE_CLASS}`);

  files.forEach((file) => {
    dropFile(file);
  });
};

let setLimiters = function() {
  textlimit(TEXTLIMIT_TEXTAREA_CLASS, TEXTLIMIT_SPAN_CLASS);
};

let linkForChat = function(event) {
  event.preventDefault();

  if (window.supportBoxApi && typeof window.supportBoxApi.open === 'function') {
    window.supportBoxApi.open();
  }
};

let setLinksForChat = function() {
  setListenersFromSelector(
    `.${CHAT_LINK_CLASS}`,
    CHAT_LINK_ACTIVE_CLASS,
    linkForChat
  );
};

export function typo() {
  initDomSlider();
  setDropFiles();
  setSelects();
  setSwitchers();
  setLimiters();
  setLinksForChat();
  setTables();

  if (querySelectorAll(`.${GALLERY_CLASS}`).length) {
    lazyJs(EMBLA_JS_FILE, EMBLA_LOADED_VAR);
  }
};
